<section class="auth-page">

  <div class="auth-orb auth-orb--1"></div>
  <div class="auth-orb auth-orb--2"></div>

  <div class="auth-canvas">
    <div class="auth-card">

      <div class="auth-card-header">
        <a routerLink="/">
          <img src="assets/images/Logo ver 1.png" alt="Radwa Khallaf" class="auth-logo" />
        </a>
        <div class="auth-ornament">
          <span class="auth-orn-rule"></span>
          <span class="auth-orn-gem">✦</span>
          <span class="auth-orn-rule"></span>
        </div>
        <span class="auth-step-label">{{ 'signup.new_here' | translate }}</span>
        <h2 class="auth-form-title">{{ 'signup.title' | translate }}</h2>
        <p class="auth-form-sub">{{ 'signup.sub' | translate }}</p>
      </div>

      <form class="auth-form" [formGroup]="formRegister">

        <div class="form-group-lux">
          <label for="username">{{ 'signup.username_label' | translate }}</label>
          <input
            type="text"
            id="username"
            formControlName="username"
            class="lux-input"
            [placeholder]="'signup.username_placeholder' | translate"
            autocomplete="username"
            appPreventSpaceDirective
          />
          <span class="field-hint">{{ 'signup.username_hint' | translate }}</span>
          <span class="field-error" *ngIf="(formRegister.controls.username.touched || formStatus) && formRegister.controls.username.errors?.['required']">
            {{ 'signup.username_required' | translate }}
          </span>
        </div>

        <div class="form-group-lux">
          <label for="email">{{ 'signup.email_label' | translate }}</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="lux-input"
            [placeholder]="'signup.email_placeholder' | translate"
            autocomplete="email"
          />
          <span class="field-error" *ngIf="(formRegister.controls.email.touched || formStatus) && formRegister.controls.email.errors?.['required']">
            {{ 'signup.email_required' | translate }}
          </span>
          <span class="field-error" *ngIf="formRegister.controls.email.errors?.['pattern']">
            {{ 'signup.email_invalid' | translate }}
          </span>
        </div>

        <div class="form-group-lux">
          <label for="phone_number">{{ 'signup.phone_label' | translate }}</label>
          <input
            type="tel"
            id="phone_number"
            formControlName="phone_number"
            class="lux-input"
            [placeholder]="'signup.phone_placeholder' | translate"
            autocomplete="tel"
          />
          <span class="field-error" *ngIf="(formRegister.controls.phone_number.touched || formStatus) && formRegister.controls.phone_number.errors?.['required']">
            {{ 'signup.phone_required' | translate }}
          </span>
          <span class="field-error" *ngIf="formRegister.controls.phone_number.errors?.['pattern']">
            {{ 'signup.phone_invalid' | translate }}
          </span>
        </div>

        <div class="form-group-lux">
          <label for="password">{{ 'signup.password_label' | translate }}</label>
          <input
            type="password"
            id="password"
            formControlName="password"
            class="lux-input"
            [placeholder]="'signup.password_placeholder' | translate"
            autocomplete="new-password"
          />
          <span class="field-hint">{{ 'signup.password_hint' | translate }}</span>
          <span class="field-error" *ngIf="(formRegister.controls.password.touched || formStatus) && formRegister.controls.password.errors?.['required']">
            {{ 'signup.password_required' | translate }}
          </span>
        </div>

        <button
          type="button"
          (click)="submit()"
          class="btn-auth"
        >
          {{ 'signup.submit' | translate }}
        </button>

      </form>

      <p class="auth-switch">
        {{ 'signup.have_account' | translate }}
        <a routerLink="/login">{{ 'signup.signin' | translate }}</a>
      </p>

    </div>
  </div>

</section>
